import { Input, Select, Textarea } from '@chakra-ui/react'
import { FormikProps } from 'formik'
import { get, set } from 'lodash'
import React from 'react'
import { DynamicFieldProps } from './DynamicForm'

export const renderField = (
  fieldProps: DynamicFieldProps,
  formikProps: FormikProps<any>
): JSX.Element | null => {
  switch (fieldProps.type) {
    case 'input':
    case 'date':
      return (
        <Input
          id={fieldProps.id}
          type={fieldProps.type === 'date' ? 'date' : 'text'}
          value={formikProps.values[fieldProps.id]}
          onChange={formikProps.handleChange}
          onBlur={formikProps.handleBlur}
          {...fieldProps.inputProps}
        />
      )
    case 'textarea':
      return (
        <Textarea
          id={fieldProps.id}
          value={formikProps.values[fieldProps.id]}
          onChange={formikProps.handleChange}
          onBlur={formikProps.handleBlur}
          {...fieldProps.textAreaProps}
        />
      )
    case 'select':
      return (
        <Select
          id={fieldProps.id}
          value={formikProps.values[fieldProps.id]}
          onChange={formikProps.handleChange}
          onBlur={formikProps.handleBlur}
          {...fieldProps.selectProps}
        >
          {fieldProps.options?.map((option) => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </Select>
      )
    default:
      return null
  }
}

export const getFieldValue = (values: any, fieldId: string) => get(values, fieldId)

export const setFieldTouched = (formikProps: any, fieldId: string, isTouched: boolean = true) => {
  const touched = set({ ...formikProps.touched }, fieldId, isTouched)
  formikProps.setTouched(touched)
}

export const setFieldValue = (formikProps: any, fieldId: string, value: any) => {
  const values = set({ ...formikProps.values }, fieldId, value)
  formikProps.setValues(values)
}
